module.exports = __webpack_public_path__ + "1a009aff268d3c74618bbad219ff1c1e.png";